<script setup lang="ts">
import type { CardSize } from '~/utils/card'

const { size = 'small' } = defineProps<{
  size?: CardSize
}>()
</script>

<template>
  <div class="w-full h-full rounded-4xl bg-surface-primary dark:bg-moss-500 p-m flex flex-col items-center text-center gap-4 z-0">
    <div
      class="bg-carbon-200 rounded-4xl"
      :class="{
        'size-[224px]': size === 'small',
        'size-[300px]': size === 'medium',
        'size-[400px]': size === 'large',
      }"
    />
    <Skeleton class="w-2/3 h-6 bg-carbon-200 rounded" />
    <Skeleton class="w-4/5 h-3 bg-carbon-100 rounded" />
    <Skeleton class="w-4/6 h-3 bg-carbon-100 rounded" />
  </div>
</template>
